import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, Activity, Battery } from 'lucide-react';
export function AgitationSection() {
  const painPoints = [{
    icon: <Activity size={24} data-id="element-1" />,
    text: 'Ese dolor que vuelve siempre, esa inflamación que no cede.'
  }, {
    icon: <Battery size={24} data-id="element-2" />,
    text: 'Ese cansancio que ninguna cantidad de café puede curar.'
  }, {
    icon: <AlertCircle size={24} data-id="element-3" />,
    text: 'Saltar de médico en médico sin obtener respuestas reales.'
  }];
  return <section className="py-24 bg-white" data-id="element-4">
      <div className="max-w-4xl mx-auto px-6" data-id="element-5">
        <FadeIn data-id="element-6">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-holistic-earth mb-12" data-id="element-7">
            ¿Estás cansada de saltar de médico en médico sin obtener respuestas
            reales?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-8">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.2} className="bg-holistic-sand/50 p-6 rounded-2xl text-center" data-id="element-9">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white text-holistic-earth-light mb-4 shadow-sm" data-id="element-10">
                {point.icon}
              </div>
              <p className="text-holistic-earth font-medium" data-id="element-11">{point.text}</p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-12">
          <div className="bg-holistic-cream border border-holistic-sand p-8 md:p-12 rounded-3xl relative overflow-hidden" data-id="element-13">
            <div className="absolute top-0 left-0 w-2 h-full bg-holistic-sage" data-id="element-14"></div>
            <p className="text-xl md:text-2xl text-holistic-earth leading-relaxed font-serif italic mb-6" data-id="element-15">
              "No son errores de tu cuerpo, son mensajes."
            </p>
            <div className="space-y-4 text-holistic-earth-light text-lg" data-id="element-16">
              <p data-id="element-17">
                En Argentina, vivimos bajo un estrés que nos mantiene en alerta
                constante. Tu cuerpo no se enferma por azar; se enferma por
                emociones no resueltas que quedan atrapadas en tus células.
              </p>
              <p className="font-medium text-holistic-earth" data-id="element-18">
                Si solo tratas el síntoma con pastillas, estás apagando la
                alarma pero dejando que el incendio siga creciendo por dentro.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}